import { render, staticRenderFns } from "./DataSourceTemplateForm.vue?vue&type=template&id=3f3b866c&"
import script from "./DataSourceTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./DataSourceTemplateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports